/**
 * @author Ariel
 * @date 2020-09-21
 * @desc 活动环节管理列表页配置
 */
import React from 'react'
import {component_tool} from '../../../../tool';

let {WizModal} = component_tool;
let componentName = 'activityPart'

const columns = [
  {
    name: 'id',
    formItem: {type: 'hidden'}
  },
  {
    name: 'activityId',
    formItem: {type: 'hidden'}
  },
  {
    title: '环节名称',
    name: 'title',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '环节类型',
    name: 'type',
    searchItem: {type: 'select'},
    tableItem: {},
    dict: [
      {code: 0, codeName: '课程'},
      {code: 1, codeName: '考试'},
      {code: 2, codeName: '投票'},
      {code: 3, codeName: '系列化课程'},
      {code: 4, codeName: '图片'},
      {code: 5, codeName: '链接'},
      {code: 6, codeName: '视频'},
    ]
  },
  {
    title: '环节开始时间',
    name: 'startTime',
    tableItem: {}
  },
  {
    title: '环节结束时间',
    name: 'endTime',
    tableItem: {}
  },
  {
    title: '状态',
    name: 'active',
    searchItem: {type: 'select'},
    tableItem: {},
    dict: [
      {code: 0, codeName: '关闭'},
      {code: 1, codeName: '打开'},
    ]
  },
  // {
  //   title: '积分',
  //   name: 'score',
  //   tableItem: {}
  // },
  {
    title: '参与人数',
    name: 'participateNum',
    tableItem: {}
  },
]

const templateConfig = (e) => {
  let {activityId} = e
  let type = [
    {code: 0, codeName: '课程'},
    {code: 1, codeName: '考试'},
    // {code: 2, codeName: '投票'},
    {code: 3, codeName: '系列化课程'},
    {code: 4, codeName: '图片'},
    {code: 5, codeName: '链接'},
    {code: 6, codeName: '视频'}
  ]
  let addOptions = []
  type && type.length && type.forEach(d => {
    addOptions.push(
      {
        key: 'add' + d.code,
        custom: true,
        params: {icon: 'plus', children: d.codeName, type: 'primary'},
        customOnClick: {
          key: 'jumpPage',
          params: {
            key: 'push',
            pathname: '/interact/activity/activityDetailToPart/activityPartDetailAdd',
            record: {type: d.code, activityId: activityId}
          }
        },
      }
    )
  })
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        btnAccessCheck: false,
        searchBarProps: {
          buttonSort: ['addGroup', 'export', 'participateExport'],
          buttons: [
            {
              type: 'group',
              key: 'addGroup',
              params: {
                key: '_group_btn',
                icon: 'down', children: '新增', type: 'primary'
              },
              options: addOptions
            },
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出环节信息', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  let ids = []
                  if (rows && rows.length && rows.length > 0) {
                    rows.forEach(d => {
                      ids.push(d.id)
                    })
                  }
                  return {
                    ...filters,
                    ids: ids
                  }
                }
              }
            },
            {
              key: 'participateExport',
              custom: true,
              params: {icon: 'export', children: '导出参与数据', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "participateExport",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (rows && rows.length && rows.length == 1) {
                    let id ;
                    rows.forEach(d => {
                      id = d.id
                    })
                    filters = {id:id}
                    return {...filters}
                  } else {
                    WizModal.confirm({
                      title: '请选择一条数据',
                      onOk: () => {},
                      onCancel() {}
                    })
                  }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['update', 'enable', 'look'],
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/interact/activity/activityDetailToPart/activityPartDetailUpd"
              },
            }
          },
          {
            key: "enable",
            custom: true,
            params: {children: "打开"},
            textFormat: {
              recordKey: 'active',
              dirt: {'1': '关闭', '0': '打开',}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['active'] === 0 ? "打开" : "关闭"
                }该活动环节吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      active: record['active'] === 0 ? 1 : 0,
                      id: record['id'],
                      ...filters
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/interact/activity/activityDetailToPart/activityPartLook"
              }
            }
          },
        ]
      }
    }
  }
};

const apis = (activityId = []) => {
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {activityId: activityId}
      }
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {activityId: activityId}
      }
    },
    participateExport: {
      path: `${componentName}/participateExport`,
      payload: {
        key: `${componentName}@participateExport`,
        apiParams: {}
      }
    },
  }
}

let reduxTemplateConfig = (args) => {
  let {activityId} = args
  return {
    apis: apis(activityId),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
